module.exports = {
      id: "arrow_small_down-usage",
      viewBox: "0 0 10 8",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#arrow_small_down",
      toString: function () {
        return this.url;
      }
    }